import AppProvider from 'providers/AppProvider';
import React from 'react';
import ReactDOM from 'react-dom/client';
import BreakpointsProvider from 'providers/BreakpointsProvider';
import SettingsPanelProvider from 'pages/template/providers/SettingsPanelProvider';
import { RouterProvider } from 'react-router-dom';
import { router } from 'Routes';
//import ChatWidgetProvider from 'providers/ChatWidgetProvider';
import { AuthProvider } from 'providers/AuthProvider';
import './i18n';  // Import the i18n configuration
import "./index.css";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AppProvider>
      <AuthProvider>
        <SettingsPanelProvider>
          {/*<ChatWidgetProvider> */}
          <BreakpointsProvider>
            <RouterProvider router={router} />
          </BreakpointsProvider>
          {/*</ChatWidgetProvider>*/}
        </SettingsPanelProvider>
      </AuthProvider>
    </AppProvider>
  </React.StrictMode>
);
